import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
interface Stakes {
  value: string;
  viewValue: string;
}
interface TypeOfBet {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-accumulator',
  templateUrl: './accumulator.component.html',
  styleUrls: ['./accumulator.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccumulatorComponent {
  @Input() collapsed = false;

  selectedStakes: string;
  selectedBet: string;
  stakes: Stakes[] = [];
  subscription: Subscription;
  currency: string;

  constructor(
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.subscription = this.authService.currentCurrency$.subscribe(
      (currency) => {
        this.currency = currency;
        this.initializeStakeOptions();
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  bets: TypeOfBet[] = [
    { value: 'Win', viewValue: 'Win' },
    { value: 'Place', viewValue: 'Place' },
    { value: 'Win/Place', viewValue: 'Win/Place' },
    { value: 'Ita', viewValue: 'Ita' },
    { value: 'Trita', viewValue: 'Trita' },
  ];

  panelColor = new FormControl('red');

  initializeStakeOptions() {
    this.stakes = [
      { value: '0.50', viewValue: (this.currency || '') + ' 0.50' },
      { value: '1.00', viewValue: (this.currency || '') + ' 1.00' },
      { value: '1.50', viewValue: (this.currency || '') + ' 1.50' },
      { value: '2.00', viewValue: (this.currency || '') + ' 2.00' },
      { value: '2.50', viewValue: (this.currency || '') + ' 2.50' },
    ];
  }
}
